import { UploadStatus } from '@air/redux-uploader';

export const ACTIVE_UPLOAD_STATES = [
  UploadStatus.uploading,
  UploadStatus.queued,
  UploadStatus.paused,
  UploadStatus.preparing,
];
export const REJECTED_UPLOAD_STATES = [UploadStatus.aborted, UploadStatus.failed, UploadStatus.rejected];
